const CONCERNS = [
  {
    q: "Não sei se o jardim tem espaço suficiente para uma piscina sem perder a zona verde.",
    a: "A simulação ajuda a visualizar proporções, circulação e impacto no espaço exterior.",
  },
  {
    q: "Quero perceber uma faixa de investimento antes de chamar empresas a casa.",
    a: "Incluímos uma estimativa indicativa para ajudar a perceber se faz sentido avançar.",
  },
  {
    q: "Tenho receio de pedir orçamentos e começar logo a receber chamadas.",
    a: "Só encaminhamos para um instalador se o proprietário quiser dar esse passo.",
  },
];

export default function Concerns() {
  return (
    <section
      data-testid="concerns-section"
      className="border-b border-rule bg-bone"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 py-20 md:py-28">
        <div className="mb-12 md:mb-16 reveal">
          <div className="overline text-ink/60">Dúvidas comuns de proprietários</div>
          <h2 className="font-serif font-light text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05] mt-3 max-w-3xl">
            Antes de pedir orçamento,
            <br />
            <span className="italic text-pool-deep">vale a pena perceber.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-rule border border-rule">
          {CONCERNS.map((c, i) => (
            <article
              key={i}
              data-testid={`concern-card-${i}`}
              className="bg-paper p-7 md:p-9 flex flex-col reveal"
            >
              <span className="number-serif text-4xl md:text-5xl text-pool-deep">
                {String(i + 1).padStart(2, "0")}
              </span>
              <blockquote className="mt-6 font-serif text-xl md:text-2xl leading-snug text-ink flex-1">
                &ldquo;{c.q}&rdquo;
              </blockquote>
              <div className="mt-8 pt-6 border-t border-rule">
                <p className="text-sm md:text-[15px] text-ink/60 font-light leading-relaxed">
                  {c.a}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
